const cancelButtonSx = {
    borderColor: '#bdbdbd',
    color: '#6f6f6f',
    borderRadius: '10px',
    px: 3,
    py: 0.9,
    fontWeight: 600,
    boxShadow: 'none',
    '&:hover': {
        borderColor: '#9e9e9e',
        backgroundColor: 'rgba(111, 111, 111, 0.06)',
        boxShadow: 'none'
    },
    '&.Mui-disabled': {
        borderColor: '#d9d9d9',
        color: '#b5b5b5'
    }
};

export default cancelButtonSx;
